import React from 'react';
import Context from './context/TableContext';
import Table from '@material-ui/core/Table';
import TableHead from './TableHead/TableHead';
import TableBody from './TableBody/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import { FormattedMessage } from 'react-intl';

const DataTable = ({
  columns,
  data,
  loading,
  onRowClick = () => {},
  error,
  pagination = false,
  rowsPerPageOptions = [5, 10, 25],
  count,
  rowsPerPage = 10,
  page,
  onChangePage = () => {},
  onChangeRowsPerPage = () => {},
}) => {
  return (
    <>
      <Context.Provider value={{ columns, data, loading, error }}>
        <Table size={'small'}>
          <TableHead />
          <TableBody onRowClick={onRowClick} />
        </Table>
        {pagination && (
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            labelRowsPerPage={<FormattedMessage id={'dataTable.pagination.rowsPerPage'} />}
            labelDisplayedRows={({ from, to, count: rowCount }) => {
              return <FormattedMessage id="dataTable.pagination.summary" values={{ from, to, count: rowCount }} />;
            }}
          />
        )}
      </Context.Provider>
    </>
  );
};

export default DataTable;
